<template>
  <div class="map">
    <div class="title">
      <p class="charts-name">{{$t('top.common.recruitingSites')}}</p>
      <a href="javascript:void(0);" class="check-details"
      @click="showDetail"
        >{{$t('top.common.viewDetails')}}<span class="check-icon"></span
      ></a>
    </div>
    <div id="map"></div>
    <el-dialog
      :title="$t('top.common.recruitingSites')"
      :visible.sync="dialogVisible"
      width="60%"
      >
      <div id="map1" style="height:400px"></div>
    </el-dialog>
  </div>
</template>

<script>
import {store} from '@/store/index'
export default {
  props: {
    projectCenterList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
      mapList: [],
      store,
      dialogVisible:false
    };
  },
  watch: {
    projectCenterList: {
      handler(newVal) {
        this.mapList = newVal;
        this.queryEntryData('map');
      },
      deep: true,
    },
  },
  mounted() {
    this.queryEntryData('map');
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    queryEntryData(id) {
      document.getElementById(id).removeAttribute('_echarts_instance_');
      const chinaChart = this.$echarts.init(document.getElementById(id));
      this.myChart = chinaChart;
      const chartOption = {
        tooltip: {
          formatter:(params) => {
            let localValue;
            if (params.data) {
              localValue = params.data.value;
            } else {
              localValue = 0;
            }
            let htmlStr = `
          <div style='font-size:14px;font-weight: 500;color: #373C48;text-align:left;'> ${this.store.lang === 'zh_CN'?params.name:params.data && params.data.enName}</div>
          <p style='text-align:left;margin-top:8px;font-size:14px;'>
	          ${this.$t('top.common.recruitingNumber')}:  ${localValue}
          </p>
        `;
        //  ${this.$t('top.common.people')}
            return htmlStr;
          },
          backgroundColor: "#fff",
          textStyle: { color: "#373C48" },
          extraCssText:
            "box-shadow:  0 2px 10px 0 rgba(180,180,180,0.50);height: 68px;padding: 8px 10px 12px 10px;box-sizing: border-box;",
        },
        visualMap: {
          type: "piecewise",
          itemWidth: 11,
          itemHeight: 6,
          bottom: 'center',
          left: 0,
          text: [this.$t('top.common.recruitingNumber')],
          showLabel: true,
          inverse: true,
          pieces: [
            { lt: 10, label: "< 10", color: "#BAE7FF" },
            { gt: 10, lte: 30, label: "10 - 30", color: "#69C0FF" },
            { gt: 30, lte: 50, label: "30 - 50", color: "#1890FF" },
            { gte: 50, label: "> 50", color: "#0050B3" },
          ],
        },
        geo: {
          map: "china",
          roam: false, 
          zoom: 1.2,
          label: {
            show: false,
          },
          itemStyle: {
            borderColor: "#FFF",
            emphasis: {
              shadowBlur: 20,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                normal: {
                  opacity: 0,
                },
              },
              label: {
                show: false,
              },
            },
          ],
        },
        series: [
          {
            name: "",
            type: "map",
            geoIndex: 0,
            label: {
              show: true,
            },
            data: this.mapList,
          },
        ],
      };
      chinaChart.setOption(chartOption);
      chinaChart.on("mouseover", function () {
        chinaChart.dispatchAction({
          type: "downplay",
        });
      });
        window.addEventListener("resize", () => {
          setTimeout(() => {
            chinaChart.resize();
           }, 1000);
        });
    },
    showDetail() {
      this.dialogVisible = true;
      setTimeout(() => {
        this.queryEntryData('map1')
      }, 0)
    }
  },
};
</script>
<style scoped>
.map {
  background: #fff !important;
  padding: 19px 25px;
  height: calc(45% - 80px);
  box-sizing: border-box;
}
#map {
  width: 100%;
  height: 100%;
}
.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.charts-name {
  padding: 0;
  margin: 0;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #373c48;
  letter-spacing: 0;
}
.check-details {
  color: #999999;
  margin-left: 10px;
  text-decoration: none;
  font-size: 12px;
}
.check-icon {
  padding-left: 5px;
  padding-right: 7px;
  color: #999999;
  font-size: 12px;
  opacity: 0.6;
  position: relative;
}
.check-icon::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  border-top: 1px solid #999999;
  border-right: 1px solid #999999;
  transform: rotate(45deg);
  left: 1px;
  top: 6px;
}
.check-icon:hover {
  opacity: 1;
}
</style>